import { domainMeta } from './domainMeta';

export const getLogoUrl = (logoUrl?: string | null) => {
  if (logoUrl) {
    const { href } = new URL(logoUrl, domainMeta.monolithOrigin);
    return href;
  }
  return undefined;
};
